<script setup lang="ts">
import { footerNavigation } from "@/content/pages";
</script>

<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-links">
        <nav v-for="(items, group) in footerNavigation" :key="group" :aria-label="group">
          <strong>{{ group }}</strong>
          <RouterLink v-for="item in items" :key="item.path" :to="item.path">{{ item.label }}</RouterLink>
        </nav>
      </div>
      <div class="footer-message">
        <RouterLink to="/" class="footer-brand">
          <img src="/media/app-icon.svg" alt="" width="40" height="40" /><span>MySimpleBible</span>
        </RouterLink>
        <h2>Read. Remember. Pray.</h2>
        <p>Scripture, listening, notes, and prayer. Together on your device.</p>
      </div>
    </div>
    <div class="footer-bottom"><span>© 2026 MySimpleBible</span><span>iPhone &amp; Android <span aria-hidden="true">·</span> Offline First</span><a href="#main-content">Back To Top ↑</a></div>
  </footer>
</template>
